




















































































import { IInventoryAdvancePayment, IUser } from '@/models';
import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import InventoryAdvancePaymentAPSpecialistPicker from './InventoryAdvancePaymentAPSpecialistPicker.vue';

export default Vue.extend({
  name: 'InventoryAdvancePaymentAPSpecialistListMenu',

  components: { InventoryAdvancePaymentAPSpecialistPicker },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      apSpecialistLoading: false,
      apSpecialistDialog: false,
      errorMessage: '',
      // assign the current apSpecialist to inventoryAdvancePayment apSpecialist
      apSpecialist: null as null | number
    };
  },

  watch: {
    apSpecialistDialog(value: boolean) {
      if (value == true) {
        if (this.inventoryAdvancePayment.ap_specialist) {
          this.apSpecialist =
            (this.inventoryAdvancePayment.ap_specialist as IUser).id ??
            (this.inventoryAdvancePayment.ap_specialist as number);
        }
      }
    }
  },

  methods: {
    ...mapActions({
      assignInventoryAdvancePaymentAPSpecialist:
        'inventoryAdvancePayment/assignInventoryAdvancePaymentAPSpecialist'
    }),

    closeDialog() {
      this.errorMessage = '';
      this.apSpecialistLoading = false;
      this.apSpecialistDialog = false;
    },

    clearErrors() {
      this.errorMessage = '';
    },

    setInventoryAdvancePaymentAPSpecialist(apSpecialist: number) {
      this.apSpecialistLoading = true;
      this.assignInventoryAdvancePaymentAPSpecialist({
        inventoryAdvancePaymentId: this.inventoryAdvancePayment.id,
        apSpecialist
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          } else {
            this.errorMessage = 'Error assigning Ap Specialist';
          }
        })
        .finally(() => {
          this.apSpecialistLoading = false;
        });
    }
  }
});
